(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  //event listener to change transparent background to white or black
  const header3 = document.querySelector('.header__background--3');
  const header = document.querySelector('#shopify-section-header');
  const menuDrawerContainer = document.querySelector('#Details-menu-drawer-container');
  const announcementBar = document.querySelector('#shopify-section-announcement-bar');
  const iconHamburger = document.querySelector('.header__hamburger');
  const iconClosing = document.querySelector('.header__closing');

  const scrollListener = () => {
    if (window.scrollY > 72) {
      header3.classList.remove('header__background--3');
      if (header3.classList.contains('header__background--3-white')) {
        header3.classList.add('header__background--2');
      } else {
        header3.classList.add('header__background--1');
      }
    } else {
      header3.classList.remove('header__background--2');
      header3.classList.remove('header__background--1');
      header3.classList.add('header__background--3');
    }
  };

  if (header3) {
    if (header3.dataset.template === 'index' && header) {
      header.style.height = 'auto';
    }
    document.addEventListener('scroll', scrollListener);
  } else {
    document.removeEventListener('scroll', scrollListener);
  }

  // Event listener to handle mobile menu header background color change
  const mobileDropdown = document.querySelector('.header__icon');
  const headerElWhite = document.querySelector('.header__background--3-white');
  const headerElBlack = document.querySelector('.header__background--3-black');
  const mobileClick = (elem, className) => {
    return () => {
      if (!elem.classList.contains(className)) {
        elem.classList.add(className);
      } else if (elem.classList.contains(className)) {
        elem.classList.remove(className);
      }
    };
  };

  if (headerElWhite) {
    mobileDropdown.addEventListener('click', mobileClick(headerElWhite, 'header__mobile-dropdown--1'));
  } else if (headerElBlack) {
    mobileDropdown.addEventListener('click', mobileClick(headerElBlack, 'header__mobile-dropdown--2'));
  }

  if (menuDrawerContainer) {
    menuDrawerContainer.addEventListener('toggle', () => {
      const zIndexHeader = 1000000;
      const zIndexAnnouncementBar = zIndexHeader + 1;

      if (menuDrawerContainer.open) {
        header?.style.setProperty('z-index', zIndexHeader);
        announcementBar?.style.setProperty('z-index', zIndexAnnouncementBar);
        iconHamburger?.style.setProperty('display', 'none');
        iconClosing?.style.setProperty('display', 'block');
      } else {
        header?.style.removeProperty('z-index');
        announcementBar?.style.removeProperty('z-index');
        iconHamburger?.style.setProperty('display', 'block');
        iconClosing?.style.setProperty('display', 'none');
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
